import React from 'react'
import styled from '@emotion/styled'
import DialogBarHeader from './DialogBarHeader'
import DialogsContainer from './DialogsContainer'
import Dialog from './Dialog'
import { useSelector, useDispatch } from 'react-redux'
import { fetchInteractions } from 'state/actions'

import Empty from 'components/shared/Empty'
import Spinner from 'components/shared/Spinner'
import Scrollable from 'components/shared/Scrollable'
import { getFilterTitles } from 'shared/utils/titles'
import empty from 'assets/emptyInteractions.png'

import _ from 'lodash'

import {
  areInteractionsRequesting,
  getInteractions,
  // getInteractionsPage,
  getInteractionsNextPage,
  getSelectedInboxTitle,
  getSelectedFilter
} from 'state/selectors'

const DialogBarContainer = styled.div`
  position: relative;
  min-width: 297px;
  width: 18.5625%;
  padding-bottom: 32px;
  height: 100vh;
`
const Image = styled.img`
  display: block;
  margin: auto;
`

const DialogBar = () => {
  const interactions = useSelector(getInteractions)
  const isLoading = useSelector(areInteractionsRequesting)
  // const currentPage = useSelector(getInteractionsPage)
  const nextPage = useSelector(getInteractionsNextPage)
  const inboxTitle = useSelector(getSelectedInboxTitle)
  const filterTitle = useSelector(getSelectedFilter)
  const dispatch = useDispatch()

  const handleLoad = () => {
    if (!isLoading && nextPage > 0) {
      dispatch(fetchInteractions())
    }
  }

  return (
    <DialogBarContainer>
      {(inboxTitle || filterTitle) &&
        <DialogBarHeader>{inboxTitle || getFilterTitles(filterTitle)}</DialogBarHeader>
      }
      {isLoading && <Spinner />}
      {(!isLoading && !interactions.length)
        ? (<Empty>
          <Image
            src={empty}
            title={'Your inbox is empty'}
          />Your inbox is empty</Empty>)
        : (<DialogsContainer>
          <Scrollable
            handleLoad={_.debounce(handleLoad, 600)}
          >
            {
              interactions?.map(interaction =>
                <Dialog
                  key={interaction.interactionId}
                  interaction={interaction}
                />
              )
            }
          </Scrollable>
          {/*<Scroller*/}
          {/*  hasMore={!isLoading && nextPage > 0}*/}
          {/*  handleLoad={_.debounce(() => dispatch(fetchInteractions()), 750)}*/}
          {/*>*/}
          {/*  {*/}
          {/*      interactions?.map( interaction =>*/}
          {/*        <Dialog*/}
          {/*          key={interaction.interactionId}*/}
          {/*          interaction={interaction}*/}
          {/*        />)*/}
          {/*  }*/}
          {/*</Scroller>*/}
        </DialogsContainer>)
      }
    </DialogBarContainer>
  )
}
export default DialogBar
